import React from 'react';
import { Typography } from 'antd';
import { Spinner } from '@doer/frontend-components/spinner';
import type { FormField } from '../../../../types/templates';
import { CustomTooltip } from '../custom-tooltip';

const { Text } = Typography;

interface Props {
  field: FormField;
  onUpload: (file: File) => void;
  isUploading?: boolean;
  hint?: string;
  width?: number | string;
}

export const UploadTile: React.FC<Props> = ({ field, onUpload, isUploading, hint, width = 110 }) => {
  const [hovered, setHovered] = React.useState(false);
  return (
    <CustomTooltip field={field}>
      <label
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          flexShrink: 0,
          width,
          height: '100%',
          boxSizing: 'border-box',
          border: hovered ? '1px dashed rgba(0,0,0,0.4)' : '1px dashed rgba(0,0,0,0.2)',
          borderRadius: 8,
          cursor: 'pointer',
          background: hovered ? 'var(--color-background-secondary)' : 'var(--color-background-primary)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4,
          transition: 'border-color 0.12s, background 0.12s'
        }}
      >
        <input
          type='file'
          accept='image/jpeg,image/jpg,image/png'
          style={{ display: 'none' }}
          onChange={e => {
            const file = e.target.files?.[0];
            if (file) onUpload(file);
            e.target.value = '';
          }}
        />
        {isUploading ? (
          <Spinner size={16} />
        ) : (
          <Text type='secondary' style={{ fontSize: 22, lineHeight: 1 }}>
            +
          </Text>
        )}
        <Text type='secondary' style={{ fontSize: 10, textAlign: 'center', padding: '0 6px' }}>
          {isUploading ? 'Subiendo...' : 'Subir'}
        </Text>
        {hint && (
          <Text type='secondary' style={{ fontSize: 9, textAlign: 'center', padding: '0 6px', lineHeight: 1.3 }}>
            {hint}
          </Text>
        )}
      </label>
    </CustomTooltip>
  );
};
